import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Line from '../../../../../common/chart/chartContainer/Line'
import { Icon } from '../../../../../common/html/icon'
import { Tooltip } from '../../../../../common/tooltip'
import { valToPercent } from '../../../../../helpers/value'
import CustomizedLabelLine from '../../common/CustomizedLabelLine'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  handleIconDownload,
} from '../../helper'
import classes from '../../index.module.scss'
import { CHARTS } from './constant'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

const Trend = ({ isDynamicReport, isDownloadComponent, id, check = [] }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const charts = CHARTS.filter(
    ({ dataKey }) => !isDynamicReport || check.includes(dataKey),
  )

  const isH100 = charts.length >= 3

  return (
    <div
      style={{
        height: isDownloadComponent
          ? '100%'
          : getStyleHeightContainer(
              isDynamicReport,
              isNoData,
              isH100 ? 332 : 332 / 2,
            ),
      }}
      className={classes.coverageTrendContainer}
    >
      {charts.map((chart, index) => {
        return (
          <div
            key={index}
            className={`${isH100 ? 'h50' : 'h100'} w50 flexColumn ${
              classes.chart
            }`}
          >
            <div className="fw600 dFlex alignItemsCenter">
              <span>{indicatorById[chart.dataKey]?.ratioName}</span>
              {!isDynamicReport &&
                !isDownloadComponent &&
                chart.tooltipContent && (
                  <Tooltip
                    elementName="span"
                    tooltipContent={chart.tooltipContent}
                  >
                    <Icon
                      className="icon-info-circle ml1"
                      style={{ color: '#9C9C9C', marginTop: 2 }}
                    />
                  </Tooltip>
                )}
            </div>
            <div className="h100 pt1">
              <ChartContainer
                data={dataByTrend}
                margin={{ top: 15, left: 10, bottom: 0, right: 10 }}
                width="100%"
                height="100%"
                xAxis={[
                  {
                    dataKey: 'year',
                    padding: { left: 15, right: 15 },
                    tickMargin: 3,
                    height: 18,
                  },
                ]}
                yAxis={[
                  {
                    yAxisId: 'left',
                    dataKeys: [chart.dataKey],
                    isLineChart: true,
                    hide: true,
                  },
                ]}
                tooltip={{
                  schema: {
                    content: [
                      {
                        dataKey: chart.dataKey,
                        label: I18n.t(chart.title),
                        isI18n: true,
                        formatValue: (value) => valToPercent(value, locale),
                      },
                    ],
                  },
                }}
              >
                <Line
                  yAxisId="left"
                  dataKey={chart.dataKey}
                  stroke={chart.color}
                  label={
                    <CustomizedLabelLine
                      formatValue={(value) => valToPercent(value, locale)}
                    />
                  }
                />
              </ChartContainer>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Trend
